module.exports = __webpack_public_path__ + "img/petite1.3788d2f2.jpg";